import { useAppSelector } from '@hooks/reduxHooks';
import axios from 'axios';
import { useQuery } from 'react-query';

export const useChangeVersion = () => {
  const version = useAppSelector(state => state.userReducer.version);

  const { ...args } = useQuery<{ version: string }>({
    queryKey: ['change-version', version],
    queryFn: async () => {
      const res = await axios.get('/version.json');

      return res.data;
    },
    refetchInterval: 90 * 1000
  });

  return { ...args, changeVersion: args?.data?.version && args?.data?.version !== version };
};
